import React from "react";
import { CardContent } from "@mui/material";
import {
    StyledCard,
    StyledDivider,
    StyledTypography,
} from "components/Screens/Company/CompanySummary";
import Markdown from "components/Common/Markdown/Markdown";
import { CompanySummary } from "../types";

interface Props {
    recentUpdates: CompanySummary["recent_updates_markdown"];
}

const RecentUpdatesSection: React.FC<Props> = ({ recentUpdates }) => {
    if (!recentUpdates) {
        return null;
    }

    return (
        <StyledCard mb={16}>
            <CardContent>
                <StyledTypography
                    variant="h6"
                    color="primary"
                    fontWeight="bold"
                >
                    Recent Updates
                </StyledTypography>
                <StyledDivider sx={{ my: 2 }} />
                <Markdown text={recentUpdates} fontSize="16px" />
            </CardContent>
        </StyledCard>
    );
};

export default RecentUpdatesSection;
